<template>
  <div class="main-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="home-log">
          <img src="@/assets/img/home-edu.png" />
        </span>
        <span class="bread" @click="back">现场确认预约管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="main-color">{{title}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin-top:10px">
        <el-card shadow="never">
            <el-form :model="form" :rules="rules" ref="form" label-width="300px">
            <el-form-item label="预约日期：" prop="confirm_date">
                <el-date-picker v-model="form.confirm_date" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width:300px"></el-date-picker>
            </el-form-item>
            <el-form-item label="时间：" prop="confirm_time">
                <el-input v-model="form.confirm_time"  style="width:200px"></el-input>
            </el-form-item>
            <el-form-item label="总人数：" prop="number">
                <el-input-number v-model="form.number" :min="0" :step="1" step-strictly :controls="false" style="width:200px"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="医院名称：" prop="hospital">
                <el-input v-model="form.hospital" style="width:500px"></el-input>
            </el-form-item> -->
            <el-form-item label="地址：" prop="address">
                <el-input v-model="form.address" style="width:500px"></el-input>
            </el-form-item>
            <el-form-item>
                <div style="padding:20px;">
                <el-button type="default" @click="back">返回</el-button>
                <el-button type="primary" @click="submitClick('form')" style="margin-left:40px">提交</el-button>
            </div>
            </el-form-item>
            
        </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title:'新增',
      form: {
        id:0,
        confirm_date:'',
        confirm_time:'',
        number:undefined,
        address:''
      },
      rules: {
        confirm_date: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        confirm_time: [
          { required: true, message: "请输入时间", trigger: "blur" }
        ],
        number: [{ required: true, message: "请输入总人数", trigger: "blur" }],
        // hospital: [
        //   { required: true, message: "请输入医院名称", trigger: "blur" }
        // ],
        address: [
          { required: true, message: "请输入地址", trigger: "blur" }
        ]
      },
    };
  },
  mounted() {
    this.form.id = this.$route.params.id || 0
    if(this.form.id != 0){
      this.title = '编辑'
      this.getInfo()
    }
  },
  methods: {
    getInfo(){
      this.$request.getNDNF(this.$url.type.base,this.$url.edu.categoryQuery+"?id="+this.form.id,success=>{
        this.form.name = success.result.name
        this.form.rate = success.result.rate
        this.form.owner = success.result.owner
        this.form.grades = success.result.grades
        this.form.base = success.result.base
        this.listRightForm = success.result.customer.map(item=>{
          if(item.type == 'checkbox'){
            item.value = []
          }
          let obj = {}
          obj.actived = false
          obj.ele = item.type
          obj.obj = item
          return obj
        })
      })
    },
    submitClick(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$message.warning("请完善必填信息");
          return;
        }
      });
    },
    submit() {
      if(this.form.id == 0){
        this.addInfo()
      }else{
        this.editInfo()
      }
    },
    addInfo(){
      this.$request.postFormNF(
        this.$url.type.base,
        this.$url.edu.confirmAdd,
        this.form,
        success => {
          this.$message.success("提交成功");
          this.back();
        }
      );
    },
    editInfo(){
      // this.$request.postNF(
      //   this.$url.type.base,
      //   this.$url.edu.projectEdit,
      //   this.form,
      //   success => {
      //     this.$message.success("提交成功");
      //     this.back();
      //   }
      // );
    },
    back() {
      this.$router.push("/eduHome/confirmList");
    }
  }
};
</script>
<style scoped>
</style>
